import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Button from '@components/common/Button'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F5F7FA',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: '8rem',
          fontWeight: 700,
          color: '#1B5E7A',
          lineHeight: 1,
        }}
      >
        404
      </Typography>
      <Typography variant="h5" fontWeight={600} mt={2}>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={1} maxWidth={400}>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </Typography>
      <Box mt={4} display="flex" gap={2}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
      </Box>
    </Box>
  )
}

export default NotFound
